module.exports = __webpack_public_path__ + "static/img/8.031802d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/8.png
// module id = dfPV
// module chunks = 0